import { Box, styled } from '@mui/material'

export const Wrapper = styled(Box, {
  shouldForwardProp: (props) => props !== 'scrollable',
})<{ scrollable: boolean }>(({ theme, scrollable }) => ({
  width: '264px',
  transition: ' 0.3s solid ease-in',
  overflow: 'hidden',
  padding: theme.spacing(2),
  height: scrollable ? '100vh' : 'auto',
  ...(scrollable && { overflow: 'scroll' }),
  [theme.breakpoints.between('xs', 'sm')]: {
    width: '100vw',
  },
}))

export const SidebarSectionHeader = styled('h4')(({ theme }) => ({
  textTransform: 'uppercase',
  fontSize: '10px',
  color: theme.palette.text.secondary,
  fontWeight: 'bold',
}))
